"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("../styles"));

var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));

var _excluded = ["classes"];
// Necessary design tokens are imported here
//import { } from '../styles/tokens';
var styles = {
  // Necessary style overrides are set here
  // See Material UI documentation for available CSS classes to override
  root: {}
};
/**
 * Table component for the label of a column sort
 */

var TableSortLabel = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = {
    // Necessary style overrides are set here
    // See Material UI documentation for available CSS classes to override
    root: classes.root
  };
  return /*#__PURE__*/_react.default.createElement(_TableSortLabel.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});

TableSortLabel.muiName = 'TableSortLabel';
TableSortLabel.propTypes = {
  /**
   * If true, the table row will have the selected shading.
   */
  active: _propTypes.default.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,

  /**
   * The current sort direction.
   */
  direction: _propTypes.default.oneOf(['asc', 'desc'])
};
TableSortLabel.displayName = 'TableSortLabel'; // If default props are needed, they must be set here

TableSortLabel.defaultProps = {
  active: false,
  direction: 'desc'
};

var _default = (0, _styles.default)(styles)(TableSortLabel);

exports.default = _default;